import transform from 'lodash/transform';
import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { createResponsiveStateReducer } from 'redux-responsive';
import { globalMessages } from './globalMessageReducer';
import { status } from './statusReducer';
import { ui } from './uiReducer';
import { config, sections, project } from './appReducers';
import { titles } from './titleReducer';
import { geoData } from './geoDataReducer';
import { metaData } from './metaDataReducer';
import { players } from './playerReducer';

const breakPointReducer = createResponsiveStateReducer({
  // Match Bootstrap's breakpoints
  xs: 575,
  sm: 767,
  md: 991,
  lg: 1199,
}, {
  infinity: 'xl',
  extraFields: ({ greaterThan, lessThan, is }) => ({
    greaterThanOrEqual: transform(greaterThan, (result, value, mediaType) => {
      result[mediaType] = value || is[mediaType];
    }, {}),
    lessThanOrEqual: transform(lessThan, (result, value, mediaType) => {
      result[mediaType] = value || is[mediaType];
    }, {}),
  }),
});

export default combineReducers({
  routing: routerReducer,
  breakpoint: breakPointReducer,
  config,
  geoData,
  globalMessages,
  metaData,
  players,
  project,
  sections,
  status,
  titles,
  ui,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js